import moment from 'moment';
import React, { Component } from 'react'
import config from "../../../config";
import { FORMAT_NUMBER, CURRENCY, SYMBOL, Datos_Empresa } from '../../../libs/utils/Const';
import { development } from "../../../libs/utils/Const";



class SalesSeller extends Component {

    render() {
        const { ReportsModel, DocsToPrint } = this.props;
        const sellerSales = (DocsToPrint && DocsToPrint[0]) ? DocsToPrint[0] : [];
        const today = moment(new Date()).format('MM/DD/YYYY');
        const _user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        return (
            <>
                <table><tr><td>
                    <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "2.5vw" }}>
                        <div className="row">
                            <div className="col-3">
                                <img src={development? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
                                <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /></p>
                            </div>
                            <div className="col-6 text-center">
                                <h5><strong>INFORME DE VENTAS VENDEDORES SUCURSAL</strong></h5>
                            </div>
                            <div className="col-3">
                                <span className="text-left"><strong>Código sucursal:</strong>{_user?.Branch.CodeBranchOffice ?? ''}</span>
                                <p><br /><strong> DIRECCIÓN: </strong> {_user?.Branch.Address ?? ''} <br /><strong>FECHA:</strong>  {today ?? ''} <br /><strong> USUARIO:</strong> {_user?.U_NAME}</p>
                            </div>
                        </div>

                        <div className='row mt-5' style={{ paddingRight: "15px" }}>

                            <div className='col-12'>

                                {sellerSales && sellerSales.length > 0 &&
                                    sellerSales.map((sellerInfo) => {
                                        return (
                                            <>
                                                {ReportsModel.checkCashNotes ?
                                                    sellerInfo && sellerInfo.checkCashNotes.length > 0 ?
                                                        <>
                                                            <table>
                                                                <thead>
                                                                    <tr >
                                                                        <td className="text-left" colSpan={9} style={{ background: "#dee2e6" }}><strong>{sellerInfo.idEmployee ?? ''} - {sellerInfo.nameEmployee ?? ''}</strong></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-left">Fecha - Folio</th>
                                                                        <th className="text-center">Total Items</th>
                                                                        <th className="text-right">Subtotal</th>
                                                                        <th className="text-right">Total</th>
                                                                    </tr>
                                                                </thead>
                                                                {sellerInfo.checkCashNotes.map((checkCashNote) => {
                                                                    return (
                                                                        <>
                                                                            <tbody >
                                                                                <tr>
                                                                                    <td className="text-left">{(checkCashNote && moment(checkCashNote.DocDate).format('MM/DD/YYYY')) ?? ''} .- <strong>{(checkCashNote && checkCashNote.NumAtCard) ?? ''}</strong></td>
                                                                                    <td className="text-center">{checkCashNote ? checkCashNote.TotalLineas : 0}</td>
                                                                                    <td className="text-right">{checkCashNote ? CURRENCY + ' ' + FORMAT_NUMBER.new(checkCashNote.DocTotal - checkCashNote.VatSum) : 0}</td>
                                                                                    <td className="text-right">{checkCashNote ? CURRENCY + ' ' + FORMAT_NUMBER.new(checkCashNote.DocTotal) : 0}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </>
                                                                    )
                                                                })}
                                                                <tr>
                                                                    <td colspan="3"></td>
                                                                    <td className="text-right"><strong>No. Operaciones: </strong></td>
                                                                    <td className="text-right"><strong> {sellerInfo.checkCashNotes.length ?? ''}</strong></td>
                                                                </tr >
                                                                <tr style={{ borderBottom: "solid 1px" }}>  </tr >
                                                            </table>
                                                        </>
                                                        :
                                                        <>
                                                            <h6>Sin registros de ventas con esos parámetros. Empleado: {sellerInfo.idEmployee ?? ''} - {sellerInfo.nameEmployee ?? ''}</h6>
                                                        </>
                                                    : ''
                                                }

                                                {ReportsModel.checkRefounds ?
                                                    sellerInfo && sellerInfo.checkRefounds.length > 0 ?
                                                        <>
                                                            <table>
                                                                <thead>
                                                                    <tr >
                                                                        <td className="text-left" colSpan={9} style={{ background: "#dee2e6" }}><strong>{sellerInfo.idEmployee ?? ''} - {sellerInfo.nameEmployee ?? ''}</strong></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-left">Fecha - Folio</th>
                                                                        <th className="text-center">Total Items</th>
                                                                        <th className="text-right">Subtotal</th>
                                                                        <th className="text-right">Total</th>
                                                                    </tr>
                                                                </thead>
                                                                {sellerInfo.checkRefounds.map((checkRefound) => {
                                                                    return (
                                                                        <>
                                                                            <tbody >
                                                                                <tr>
                                                                                    <td className="text-left">{(checkRefound && moment(checkRefound.DocDate).format('MM/DD/YYYY')) ?? ''} .- <strong>{(checkRefound && checkRefound.NumAtCard) ?? ''}</strong></td>
                                                                                    <td className="text-center">{checkRefound.TotalLineas}</td>
                                                                                    <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(checkRefound.DocTotal - checkRefound.VatSum)}</td>
                                                                                    <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(checkRefound.DocTotal)}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </>
                                                                    )
                                                                })}
                                                                <tr>
                                                                    <td colspan="3"></td>
                                                                    <td className="text-right"><strong>No. Operaciones: </strong></td>
                                                                    <td className="text-right"><strong> {sellerInfo.checkCashNotes.length ?? ''}</strong></td>
                                                                </tr >
                                                                <tr style={{ borderBottom: "solid 1px" }}>  </tr >
                                                            </table>
                                                        </>
                                                        :
                                                        <>
                                                            <h6>Sin registros de devoluciones con esos parámetros. Empleado: {sellerInfo.idEmployee ?? ''} - {sellerInfo.nameEmployee ?? ''}</h6>

                                                        </>
                                                    : ''
                                                }


                                            </>

                                        )
                                    })
                                }


                            </div>
                        </div>

                    </div>
                </td></tr></table>
            </>
        )
    }
}

export default SalesSeller